export var ButtonVariant;

(function (ButtonVariant) {
  ButtonVariant["Primary"] = "primary";
  ButtonVariant["Secondary"] = "secondary";
  ButtonVariant["Tertiary"] = "tertiary";
})(ButtonVariant || (ButtonVariant = {}));

export var ButtonColorScheme;

(function (ButtonColorScheme) {
  ButtonColorScheme["Default"] = "default";
  ButtonColorScheme["DarkBackground"] = "darkBackground";
})(ButtonColorScheme || (ButtonColorScheme = {}));

export var ButtonSize;

(function (ButtonSize) {
  ButtonSize["Default"] = "default";
  ButtonSize["Small"] = "small";
})(ButtonSize || (ButtonSize = {}));

export var ButtonIconPosition;

(function (ButtonIconPosition) {
  ButtonIconPosition["Leading"] = "leading";
  ButtonIconPosition["Trailing"] = "trailing";
})(ButtonIconPosition || (ButtonIconPosition = {}));